var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-page"},[_c('sup',[_vm._v(_vm._s(_vm.$t((_vm.code + ".sup"))))]),_c('h1',[_vm._v(_vm._s(_vm.$t((_vm.code + ".title"))))]),_c('p',[_vm._v("\n    "+_vm._s(_vm.$t((_vm.code + ".message")))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }